// conforms to CLDR based on BCP47 tags
export type LocaleId = 'en' | 'de' | 'ch' | 'co' | 'gr' | 'it' | 'ja' | 'pl' | 'sp';

export type CurrencyCode = 'EUR';

// conforms to https://date-fns.org/docs/parse#description
export const dateFormat = 'dd.MM.yyyy';
export const dateTimeFormat = 'dd.MM.yyyy, HH:mm';
export const mediumDateFormat = 'dd MMM yyyy';

export interface TosConfig {
  impressumUrl?: string;
  privacyPolicyUrl?: string;
  supportFormUrl?: string;
  termsAndConditionsUrl?: string;
}
export abstract class EnvConfig {
  public abstract apiUrl: NonNullable<string>;
  public stripePublishableKey?: NonNullable<string>;
  public abstract googleMapsApiKey: NonNullable<string>;
  public abstract ibanKey: NonNullable<string>;
  public abstract currencyCode: NonNullable<CurrencyCode>;
  /** For `null` `navigator.language` is used with fallback in case of unsupported locale */
  public abstract enforcedLocaleId: LocaleId | null;
  public abstract impressumUrl: NonNullable<string>;
  public abstract privacyPolicyUrl: NonNullable<string>;
  public abstract production: NonNullable<boolean>;
  public abstract supportFormUrl: NonNullable<string>;
  public abstract microsoftUrl: NonNullable<string>;
  public abstract termsAndConditionsUrl: NonNullable<string>;
  public allowPublic = false;
  public abstract tosUrls?: { [key: string]: TosConfig };
  public abstract recaptchaSiteKey?: NonNullable<string>;
  public abstract aiEngineApiUrl?: NonNullable<string>;
}
